import React, { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { AuthProvider as ContextProvider } from '@data';

const AuthProvider = ({ children }: { children: React.ReactNode }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const getLocation = useCallback(() => location, [location]);

  const redirect = useCallback(
    (to: string, state?: unknown) => {
      if (state) {
        navigate(to, { replace: true, state });
      } else {
        navigate(to, { replace: true });
      }
    },
    [navigate],
  );

  return <ContextProvider value={{ redirect, getLocation }}>{children}</ContextProvider>;
};

export default AuthProvider;
